import { render, staticRenderFns } from "./userprotocolIndex.vue?vue&type=template&id=2de5877d&scoped=true&"
import script from "./userprotocolIndex.vue?vue&type=script&lang=js&"
export * from "./userprotocolIndex.vue?vue&type=script&lang=js&"
import style0 from "./userprotocolIndex.vue?vue&type=style&index=0&id=2de5877d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de5877d",
  null
  
)

export default component.exports